<template>
  <q-page padding>
    <div class="fit row justify-between items-start">
      <div class="col-12">
        <p class="text-h6 text-brand-5 text-weight-bold titulo-pagina">
          Listagem de Permissões de Trabalho
        </p>
      </div>
    </div>
    <div class="row q-gutter-xs q-mt-sm container-inputs">
      <div
        class="col-lg-2 col-md-2 col-sm-4 col-xs-3 text-brand-5 text-weight-bold"
      >
        <div class="q-ml-sm titulo-input">Unidade</div>
        <lista-unidades-select></lista-unidades-select>
      </div>
      <div
        class="col-lg-2 col-md-1 col-sm-3 col-xs-3 text-brand-5 text-weight-bold"
      >
        <div class="q-ml-sm titulo-input">Pt ID</div>
        <q-input class="input" dense outlined v-model="pt.id"> </q-input>
      </div>
      <div
        class="col-xs-1 col-lg-2 col-md-2 col-sm-4 col-xs-4 text-brand-5 text-weight-bold"
      >
        <div class="q-ml-sm titulo-input">Nome do Emissor</div>
        <q-input class="input" dense outlined v-model="emissor.nome"> </q-input>
      </div>
      <div
        class="col-xs-2 col-lg-2 col-md-2 col-sm-4 col-xs-4 text-brand-5 text-weight-bold"
      >
        <div class="q-ml-sm titulo-input">Local</div>
        <q-input class="input" dense outlined v-model="pt.local"> </q-input>
      </div>
      <div class="col-md-2 col-sm-4 col-xs-4 text-brand-5 text-weight-bold">
        <div class="q-ml-sm titulo-input">Status</div>
        <q-select
          dense
          outlined
          v-model="model"
          multiple
          class="input"
          :options="options"
          option-value="value"
          option-label="label"
          behavior="menu"
        >
        </q-select>
      </div>
      <div
        class="col-lg-2 col-md-2 col-sm-6 col-xs-6 text-brand-5 text-weight-bold"
      >
        <div class="q-ml-sm titulo-input">Data Início</div>
        <q-input
          dense
          outlined
          class="input"
          placeholder="DD/MM/AAAA"
          v-model="data.inicial"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="data.inicial"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <p class="row aling text-brand-5 text-bold dimensionarTexto">Até</p>
      <div
        class="col-lg-2 col-md-2 col-sm-6 col-xs-6 text-brand-5 text-weight-bold"
      >
        <div class="q-ml-sm titulo-input">Data Término</div>
        <q-input
          dense
          outlined
          class="input"
          placeholder="DD/MM/AAAA"
          v-model="data.final"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="data.final"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
        <p></p>
        <q-btn
          class="btn-filtrar"
          color="primary"
          label="Filtrar"
          type="submit"
          icon="filter_alt"
          no-caps
          @click="listarPt()"
        />
      </div>
    </div>

    <div class="col-12 q-mt-xl">
      <q-table
        :grid="$q.screen.lt.sm"
        :rows="listaPt"
        :columns="columns"
        color="primary"
        class="tabela-tamanho-fixo"
        dense
        table-header-class="bg-accent text-weight-bold"
        v-model:pagination="pagination"
        :loading="loading"
        @request="handleRequest"
        flat
        hide-pagination
      >
        <template v-slot:body-cell-status="props">
          <q-td style="padding: 0; margin: 0" key="status" :props="props">
            <div
              v-if="props.row.status == 'aberto'"
              style="width: fit-content; background: #fefed1; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.status == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.status == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.status == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.status == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.status == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.status == 'finalizado'"
                style="width: fit-content; background: #e8ffec"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.status == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.status == 'aguardando_assinaturas'"
                style="width: fit-content; background: #fff6e3; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.status == 'aberto'"
                style="width: fit-content; background: #fefed1; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.status == 'encerrado'"
                style="width: fit-content; background: #f8f8f8; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.status == 'cancelado'"
                style="width: fit-content; background: #efecec"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.status == 'finalizado'"
              style="width: fit-content; background: #e8ffec; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.status == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.status == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.status == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.status == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.status == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.status == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.status == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.status == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.status == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.status == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.status == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.status == 'iniciado'"
              style="width: fit-content; background: #ecf1fe; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.status == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.status == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.status == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.status == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.status == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.status == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.status == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.status == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.status == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.status == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.status == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.status == 'encerrado'"
              style="width: fit-content; background: #f8f8f8; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.status == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.status == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.status == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.status == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.status == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.status == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.status == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.status == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.status == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.status == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.status == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.status == 'cancelado'"
              style="width: fit-content; background: #efecec; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.status == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.status == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.status == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.status == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.status == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.status == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.status == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.status == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.status == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.status == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.status == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
            <div
              v-if="props.row.status == 'aguardando_assinaturas'"
              style="width: fit-content; background: #fff6e3; padding: 2px 5px"
              class="row align items-center"
            >
              <span
                v-if="props.row.status == 'finalizado'"
                class="elipse q-mr-sm bg-positive"
              ></span>
              <span
                v-if="props.row.status == 'iniciado'"
                class="elipse q-mr-sm"
                style="background: #6391f4"
              ></span>
              <span
                v-if="props.row.status == 'aguardando_assinaturas'"
                class="elipse q-mr-sm"
                style="background: #dba700"
              ></span>
              <span
                v-if="props.row.status == 'aberto'"
                class="elipse q-mr-sm"
                style="background: #b4a913"
              ></span>
              <span
                v-if="props.row.status == 'encerrado'"
                class="elipse q-mr-sm"
                style="background: #2d3e6e"
              ></span>
              <span
                v-if="props.row.status == 'cancelado'"
                class="elipse q-mr-sm"
                style="background: #707070"
              ></span>
              <div
                v-if="props.row.status == 'finalizado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Finalizado" }}
              </div>
              <div
                v-if="props.row.status == 'iniciado'"
                style="width: fit-content; background: #ecf1fe"
                class="text-brand-5 text-bold"
              >
                {{ "Iniciado" }}
              </div>
              <div
                v-if="props.row.status == 'aguardando_assinaturas'"
                style="width: fit-content; color: #683f09"
                class="text-bold"
              >
                {{ "Em Ass." }}
              </div>
              <div
                v-if="props.row.status == 'aberto'"
                style="width: fit-content; color: #b4a913"
                class="text-bold"
              >
                {{ "Em Aberto" }}
              </div>
              <div
                v-if="props.row.status == 'encerrado'"
                style="width: fit-content; color: #192957"
                class="text-bold"
              >
                {{ "Encerrado" }}
              </div>
              <div
                v-if="props.row.status == 'cancelado'"
                style="width: fit-content"
                class="text-brand-5 text-bold"
              >
                {{ "Cancelado" }}
              </div>
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-dataHoraEmissao="props">
          <q-td :props="props">
            <div v-if="props.row.dataHoraEmissao">
              {{
                props.row.dataHoraEmissao
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
              <p style="margin: 0 0 0 9px">
                {{ props.row.dataHoraEmissao.split(" ")[1] }}
              </p>
            </div>
            <div v-else>-</div>
          </q-td>
        </template>
        <template v-slot:body-cell-dataHoraFinalizado="props">
          <q-td :props="props">
            <div v-if="props.row.dataHoraFinalizado">
              {{
                props.row.dataHoraFinalizado
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
              <p style="margin: 0 0 0 9px">
                {{ props.row.dataHoraFinalizado.split(" ")[1] }}
              </p>
            </div>
            <div v-else>-</div>
          </q-td>
        </template>
        <template v-slot:body-cell-detalhar="props">
          <q-td :props="props">
            <router-link
              :to="{
                name: 'pdt-pt-detalhe',
                params: { ptId: props.row.ptId },
              }"
            >
              <q-btn color="blue-6" round size="sm" icon="add" />
            </router-link>
          </q-td>
        </template>

        <template v-slot:body-cell-duplicar="props">
          <q-td :props="props">
            <DuplicarPt
              :pt="{
                ptId: props.row.ptId,
                unidadeId: props.row.unidadeId,
                local: props.row.local,
                descricao: props.row.descricao,
              }"
            />
          </q-td>
        </template>
        <template v-slot:body-cell-cancelar="props">
          <q-td :props="props">
            <q-btn
              color="white"
              text-color="red"
              flat
              :disable="
                props.row.status == 'finalizado' ||
                props.row.status == 'cancelado' ||
                (pCancelar.value &&
                  userLogado.tokenParsed.name != props.row.emissorNome)
              "
              round
              icon="close"
              @click="initCancel(props.row.ptId)"
            />
          </q-td>
        </template>
        <template v-slot:item="props">
          <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
            <div class="row card q-mb-md">
              <div class="col-12 q-mr-sm q-mt-sm">
                <q-card-section class="row text-brand-5 text-grid-table">
                  <div class="row col-12">
                    <span class="q-mr-xs"
                      ><strong>#:</strong> {{ props.row.ptId }}</span
                    >
                    <span
                      ><strong>Unidade:</strong>
                      {{ props.row.unidadeNome }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span class="q-mr-xs"
                      ><strong>Emissor:</strong>
                      {{ props.row.emissorNome }}</span
                    >
                    <span><strong>Local:</strong> {{ props.row.local }}</span>
                  </div>
                  <div class="col-12">
                    <span class="row q-mr-xs"
                      ><strong>Status Atual:</strong>
                      <div class="row items-center">
                        <span
                          v-if="props.row.status == 'finalizado'"
                          class="elipse q-mr-sm bg-positive"
                        ></span>
                        <span
                          v-if="props.row.status == 'iniciado'"
                          class="elipse q-mr-sm"
                          style="background: #6391f4"
                        ></span>
                        <span
                          v-if="props.row.status == 'aguardando_assinaturas'"
                          class="elipse q-mr-sm"
                          style="background: #dba700"
                        ></span>
                        <span
                          v-if="props.row.status == 'aberto'"
                          class="elipse q-mr-sm"
                          style="background: #b4a913"
                        ></span>
                        <span
                          v-if="props.row.status == 'encerrado'"
                          class="elipse q-mr-sm"
                          style="background: #2d3e6e"
                        ></span>
                        <span
                          v-if="props.row.status == 'cancelado'"
                          class="elipse q-mr-sm"
                          style="background: #707070"
                        ></span>
                        <span
                          v-if="props.row.status == 'finalizado'"
                          style="width: fit-content"
                        >
                          {{ "Finalizado" }}
                        </span>
                        <div
                          v-if="props.row.status == 'iniciado'"
                          style="width: fit-content"
                        >
                          {{ "Iniciado" }}
                        </div>
                        <div
                          v-if="props.row.status == 'aguardando_assinaturas'"
                          style="width: fit-content"
                        >
                          {{ "Em Ass." }}
                        </div>
                        <div
                          v-if="props.row.status == 'aberto'"
                          style="width: fit-content"
                        >
                          {{ "Em Aberto" }}
                        </div>
                        <div
                          v-if="props.row.status == 'encerrado'"
                          style="width: fit-content"
                        >
                          {{ "Encerrado" }}
                        </div>
                        <div
                          v-if="props.row.status == 'cancelado'"
                          style="width: fit-content"
                          class="text-brand-5"
                        >
                          {{ "Cancelado" }}
                        </div>
                      </div>
                      <span class="q-ml-sm"
                        ><strong
                          ><q-icon
                            class="q-mr-xs"
                            name="event"
                            size="14px"
                          />Data de Inicio:</strong
                        >
                        <span v-if="props.row.dataHoraEmissao">
                          {{
                            props.row.dataHoraEmissao
                              .split(" ")[0]
                              .split("-")
                              .reverse()
                              .join("/")
                          }}
                        </span>
                        <span v-else>-</span>
                      </span>
                    </span>
                  </div>
                  <div class="row col-12">
                    <span
                      ><strong
                        ><q-icon class="q-mr-xs" name="event" size="14px" />Data
                        de Término:</strong
                      >
                      <span v-if="props.row.dataHoraFinalizado">
                        {{
                          props.row.dataHoraFinalizado
                            .split(" ")[0]
                            .split("-")
                            .reverse()
                            .join("/")
                        }}
                      </span>
                      <span v-else>-</span>
                    </span>
                  </div>
                </q-card-section>
              </div>
              <div class="row col-12">
                <div class="column col-4">
                  <q-btn
                    label="Detalhe"
                    icon="add_circle_outline"
                    stack
                    class="btn"
                    style="color: white; background: #3c76f1"
                    no-caps
                    @click="detalharPt(props.row.ptId)"
                  />
                </div>
                <div class="column col-4">
                  <DuplicarPt
                    :mobile="true"
                    :pt="{
                      ptId: props.row.ptId,
                      unidadeId: props.row.unidadeId,
                      local: props.row.local,
                      descricao: props.row.descricao,
                    }"
                  />
                </div>
                <div class="column col-4">
                  <q-btn
                    label="Cancelar"
                    icon="cancel"
                    stack
                    class="btn"
                    no-caps
                    style="color: white; background: #cf1515"
                    @click="initCancel(props.row.ptId)"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
    <q-dialog v-model="cancelar">
      <q-card style="width: 700px; max-width: 80vw">
        <q-card-section>
          <div class="text-h6 text-brand-5 text-weight-bold">
            Tem certeza que deseja cancelar essa pt?
          </div>
        </q-card-section>

        <q-separator />

        <q-card-section>
          <q-input
            class="col-xs-8 col-sm-3 col-lg-2"
            dense
            outlined
            label="Observação"
            v-model="observacao"
            type="textarea"
          />
        </q-card-section>

        <q-card-section>
          <q-input
            class="col-xs-8 col-sm-3 col-lg-2"
            dense
            outlined
            label="Motivo"
            v-model="motivo"
            type="textarea"
          />
        </q-card-section>

        <q-card-section>
          <q-input
            class="col-xs-8 col-sm-3 col-lg-2"
            dense
            outlined
            label="Ação Necessaria"
            v-model="acao"
            type="textarea"
          />
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            icon="close"
            dense
            label="Voltar"
            color="negative"
            no-caps
            v-close-popup
          />
          <q-btn
            dense
            label="Cancelar PT"
            color="positive"
            icon="check_circle_outline"
            no-caps
            @click.prevent="cancelarPt"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <ScrollToTopButton />
  </q-page>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { onMounted } from "@vue/runtime-core";
import { inject, watch, computed } from "vue";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import DuplicarPt from "../components/DuplicarPt.vue";
import ScrollToTopButton from "../../../../components/ScrollToTopButton.vue";

export default {
  components: {
    ListaUnidadesSelect,
    DuplicarPt,
    ScrollToTopButton,
  },
  setup() {
    const columns = [
      {
        name: "ptId",
        label: "#",
        field: "ptId",
        align: "left",
      },
      {
        name: "unidadeNome",
        label: "Unidade",
        field: "unidadeNome",
        align: "left",
      },
      {
        name: "emissorNome",
        label: "Emissor",
        field: "emissorNome",
        align: "left",
      },
      {
        name: "local",
        label: "Local",
        field: "local",
        align: "left",
      },
      {
        name: "status",
        label: "Status",
        field: "status",
        align: "left",
      },
      {
        name: "dataHoraEmissao",
        label: "Data inicio",
        field: "dataHoraEmissao",
        align: "left",
      },
      {
        name: "dataHoraFinalizado",
        label: "Data termino",
        field: "dataHoraFinalizado",
        align: "center",
      },
      {
        name: "detalhar",
        label: "Detalhar",
        field: "ptId",
        align: "center",
      },
      {
        name: "duplicar",
        label: "Duplicar",
        field: "ptId",
        align: "center",
      },
      {
        name: "cancelar",
        label: "Cancelar",
        align: "center",
      },
    ];
    const unidade = ref();
    const listaPt = ref([]);
    const store = useStore();
    const router = useRouter();
    const keycloak = inject("keycloak");
    const userLogado = ref(keycloak);
    const coletar = ref(false);
    const ptCancel = ref(null);
    const quasar = useQuasar();
    const loading = ref(false);
    const observacao = ref("");
    const motivo = ref("");
    const pCancelar = ref(true);
    const acao = ref("");
    const model = ref([]);
    let cancelar = ref(false);
    const options = ref([
      {
        value: "aberto",
        label: "Em Aberto",
      },
      {
        value: "aguardando_assinaturas",
        label: "Em Ass.",
      },
      {
        value: "iniciado",
        label: "Iniciado",
      },
      {
        value: "encerrado",
        label: "Encerrado",
      },
      {
        value: "cancelado",
        label: "Cancelado",
      },
      {
        value: "finalizado",
        label: "Finalizado",
      },
    ]);
    let disable = ref(false);
    let recebeUnidade = ref({
      unidade: store.state.org.unidadeData.nome,
      id: store.state.org.unidadeData.id,
    });
    const data = ref({
      inicial: "11/07/2021",
      final: new Date()
        .toISOString()
        .substring(0, 10)
        .split("-")
        .reverse()
        .join("/"),
    });

    let status = ref([]);

    const pt = ref({
      id: "",
      local: "",
    });

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const emissor = ref({
      nome: "",
    });

    const listarPt = async (page = 0, rowsPerPage = 6) => {
      await store.state.org.unidadeData;
      disable.value = true;
      loading.value = true;
      let dataInicio;
      let dataFinal;

      dataInicio = data.value.inicial;
      dataFinal = data.value.final;

      if (dataInicio && dataFinal) {
        let diaInicial = data.value.inicial.split("/")[0];
        let mesInicial = data.value.inicial.split("/")[1];
        let anoInicial = data.value.inicial.split("/")[2];
        let diaFinal = data.value.final.split("/")[0];
        let mesFinal = data.value.final.split("/")[1];
        let anoFinal = data.value.final.split("/")[2];

        dataInicio = anoInicial + "/" + mesInicial + "/" + diaInicial;
        dataFinal = anoFinal + "/" + mesFinal + "/" + diaFinal;
      }

      try {
        const resposta = await store.dispatch("pdt/filtrarPtLista", {
          unidadeId: store.state.org.unidadeData.id,
          status: status.value,
          perPage: rowsPerPage,
          page: page,
          emissorNome: emissor.value.nome,
          inicio: dataInicio,
          final: dataFinal,
          ptId: pt.value.id,
          local: pt.value.local,
        });

        listaPt.value = resposta.data.resultado.dados;
        pagination.value.rowsPerPage = resposta.data.resultado.perPage;
        pagination.value.rowsNumber = resposta.data.resultado.total;
        pagination.value.page = resposta.data.resultado.currentPage;

        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.error("Erro na chamada da API:", error);
        loading.value = false;
        disable.value = false;
      }

      return;
    };

    const detalharPt = (ptId) => {
      router.push({ name: "pdt-pt-detalhe", params: { ptId } });
    };

    const initCancel = async (ptId) => {
      cancelar.value = true;
      ptCancel.value = ptId;
    };

    const cancelarPt = async () => {
      try {
        await store.dispatch("pdt/cancelarPt", {
          motivo: motivo.value,
          acoesNecessarias: acao.value,
          observacao: observacao.value,
          ptId: ptCancel.value,
        });

        quasar.notify({
          message: "Permissão cancelada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        cancelar.value = false;
        listarPt();
      } catch (error) {
        quasar.notify({
          message: "Erro a o cancelar permissão",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      listarPt(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        loading.value = true;
        handleRequest();
      }
    );

    watch(
      () => model.value,
      () => {
        let array = [];
        model.value.forEach((e) => {
          array.push(e.value);
        });
        status.value = JSON.stringify(array);
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        recebeUnidade.value.unidade = store.state.org.unidadeData.nome;
        recebeUnidade.value.id = store.state.org.unidadeData.id;
        listarPt();
      }
    );

    const permissaoCancelar = async () => {
      if (store.state.autenticacao.usuarioLogado.permissoes.gmapi) {
        if (
          store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            "pdt-cancelar"
          ) == -1
        ) {
          pCancelar.value = false;
          return;
        }
      }
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(permissaoCancelar);
    onMounted(listarPt);
    onMounted(getUnidade);

    return {
      columns,
      listaPt,
      listarPt,
      handleRequest,
      detalharPt,
      cancelarPt,
      userLogado,
      coletar,
      ptCancel,
      initCancel,
      model,
      pagination,
      loading,
      observacao,
      pCancelar,
      acao,
      motivo,
      permissaoCancelar,
      options,
      recebeUnidade,
      getUnidade,
      unidade,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      data,
      emissor,
      pt,
      status,
      cancelar,
    };
  },
};
</script>

<style scoped>
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.dimensionarTexto {
  margin-top: 35px;
}
a {
  text-decoration: none;
}
.btn-filtrar {
  margin-top: 8px;
}
@media (max-width: 600px) {
  .titulo-pagina {
    font-size: 14px;
    margin-top: 10px;
  }

  .container-inputs {
    margin: 0px 16px 0px 16px !important;
    gap: 0px !important;
  }

  .col-lg-2.col-md-2.col-sm-4.col-xs-3,
  .col-lg-2.col-md-1.col-sm-3.col-xs-3,
  .col-xs-1.col-lg-2.col-md-2.col-sm-4.col-xs-4,
  .col-xs-2.col-lg-2.col-md-2.col-sm-4.col-xs-4,
  .col-md-2.col-sm-4.col-xs-4,
  .col-lg-2.col-md-2.col-sm-6.col-xs-6,
  .col-6.col-lg-6.col-md-6.col-sm-6.col-xs-6 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 12px !important;
  }

  .titulo-input {
    margin: 0px 0px 6px 8px;
    font-size: 12px;
    font-weight: 600;
    color: #21324a;
  }

  .input {
    font-size: 16px !important;
  }

  .dimensionarTexto {
    display: none;
  }

  .btn-filtrar {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    font-size: 13px;
    width: 100% !important;
    min-height: 44px !important;
  }

  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }

  .text-grid-table {
    font-size: 11px;
  }

  .elipse {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: -1px 5px 0px 2px;
  }

  .btn {
    border-radius: 0px;
    font-size: 12px;
    min-height: 44px !important;
    width: 100% !important;
  }
}

@media (max-width: 480px) {
  .titulo-pagina {
    font-size: 16px;
    margin-top: 8px;
  }

  .container-inputs {
    margin: 0px 12px 0px 12px !important;
    gap: 0px !important;
  }

  .col-lg-2.col-md-2.col-sm-4.col-xs-3,
  .col-lg-2.col-md-1.col-sm-3.col-xs-3,
  .col-xs-1.col-lg-2.col-md-2.col-sm-4.col-xs-4,
  .col-xs-2.col-lg-2.col-md-2.col-sm-4.col-xs-4,
  .col-md-2.col-sm-4.col-xs-4,
  .col-lg-2.col-md-2.col-sm-6.col-xs-6,
  .col-6.col-lg-6.col-md-6.col-sm-6.col-xs-6 {
    margin-bottom: 10px !important;
  }

  .titulo-input {
    margin: 0px 0px 4px 6px;
    font-size: 13px;
  }

  .input {
    font-size: 16px !important;
  }

  .btn-filtrar {
    font-size: 12px;
    min-height: 42px !important;
  }

  .btn {
    border-radius: 0px;
    font-size: 12px;
    min-height: 44px !important;
    width: 100% !important;
  }

  .btn-duplicar {
    min-height: 44px !important;
    width: 100% !important;
  }
}

@media (max-width: 360px) {
  .titulo-pagina {
    font-size: 12px;
    margin-top: 6px;
  }

  .container-inputs {
    margin: 0px 8px 0px 8px !important;
    gap: 0px !important;
  }

  .col-lg-2.col-md-2.col-sm-4.col-xs-3,
  .col-lg-2.col-md-1.col-sm-3.col-xs-3,
  .col-xs-1.col-lg-2.col-md-2.col-sm-4.col-xs-4,
  .col-xs-2.col-lg-2.col-md-2.col-sm-4.col-xs-4,
  .col-md-2.col-sm-4.col-xs-4,
  .col-lg-2.col-md-2.col-sm-6.col-xs-6,
  .col-6.col-lg-6.col-md-6.col-sm-6.col-xs-6 {
    margin-bottom: 8px !important;
  }

  .titulo-input {
    margin: 0px 0px 3px 4px;
    font-size: 10px;
  }

  .input {
    font-size: 16px !important;
  }

  .btn-filtrar {
    font-size: 11px;
    min-height: 40px !important;
  }

  .btn {
    border-radius: 0px;
    font-size: 12px;
    min-height: 44px !important;
    width: 100% !important;
  }
}
</style>
